import { FormSection } from '@ksyos/design-system';
import type { ProcessActivityPatientContactDetails } from '@common/interfaces/patientContactDetails';
import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { PatientAlternativeAddressType } from '@common/validation/customControls/patientContactDetailsSchema';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { setProfessionalSummaryReadComponents } from '@frontend/components/pages/episodeCategory/customControls/processActivityProfessionalSummaryData/utils/setProfessionalSummaryReadComponents';
import { AddressFormGroupFormParagraph } from '../../../patientContactDetails/PatientContactDetailsRead';

export function getExaminationRequestReadComponentsBase(
    readSections: IProcessActivityReadSection<string, string, string>[],
    processActivityId: string
) {
    const map = new Map();

    const sendToAlternativeAddress = getProcessActivityReadSectionItem<PatientAlternativeAddressType>()(
        readSections,
        'sendToAlternativeAddress'
    );

    if (sendToAlternativeAddress?.value) {
        const alternativeAddressItems = getProcessActivityReadSectionItem<PatientAlternativeAddressType>()(
            readSections,
            'alternativeAddress'
        );

        map.set(
            'alternativeAddress',
            <FormSection title="Verstuur recorder naar adres">
                <AddressFormGroupFormParagraph address={{ ...alternativeAddressItems?.value }} />
            </FormSection>
        );
    } else {
        const patientAddressItems = getProcessActivityReadSectionItem<ProcessActivityPatientContactDetails>()(
            readSections,
            'patient'
        );

        map.set(
            'patient',
            <FormSection title="Verstuur recorder naar adres">
                <AddressFormGroupFormParagraph address={{ ...patientAddressItems?.value }} />
            </FormSection>
        );
    }

    setProfessionalSummaryReadComponents({ map, processActivityId, readSections });

    return map;
}
